import { useRouter } from "next/router"
import dynamic from "next/dynamic"
import { InferGetStaticPropsType } from "next"
import { fetchApp } from "queries"

const BestInstagramAppsAR = dynamic(
  () => import("views/articles/BestInstagramApps/ar"),
)
const BestInstagramAppsTR = dynamic(
  () => import("views/articles/BestInstagramApps/tr"),
)
const BestInstagramAppsEN = dynamic(
  () => import("views/articles/BestInstagramApps/en"),
)

const mainApps = ["588013838", "967351793", "897446215", "1247275033"]

const BestInstagramApps = ({
  apps,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const router = useRouter()
  const otherApps = apps.filter(
    (app: any) => !mainApps.includes(String(app.trackId)),
  )
  if (router.locale === "ar")
    return <BestInstagramAppsAR apps={apps} otherApps={otherApps} />
  if (router.locale === "tr-TR")
    return <BestInstagramAppsTR apps={apps} otherApps={otherApps} />
  return <BestInstagramAppsEN apps={apps} otherApps={otherApps} />
}

export default BestInstagramApps

export const getStaticProps = async () => {
  const apps = (
    await Promise.allSettled(
      [...mainApps, "1544606830", "1627898344", "1549468967", "1482740849"].map(
        (app) => fetchApp(app),
      ),
    )
  ).map((item: any) => ({
    trackId: item?.value?.trackId,
    artworkUrl512: item?.value?.artworkUrl512,
    trackName: item?.value?.trackName,
    genres: item?.value?.genres,
    description: item?.value?.description.slice(0, 50) + "...",
    formattedPrice: item?.value?.formattedPrice,
    submitterPrice: item?.value?.submitterPrice,
    price: item?.value?.price,
    submitter: item?.value?.submitters?.[0],
    appRemoved: item?.value?.appRemoved,
    hasInAppPurchases: item?.value?.hasInAppPurchases,
  }))

  return {
    props: {
      apps: JSON.parse(JSON.stringify(apps)),
    },
  }
}
